import { useLayoutEffect, useRef, useState } from "react"

/*
  The admin's own description of the event, set apart as content they wrote
  rather than page help text: a card with a label, readable dark text, and the
  line breaks they typed. Long text is clamped to three lines; "Show more"
  appears only when the text actually overflows.
*/
const EventDescription = ({ text }) => {
  const textRef = useRef(null)
  const [isExpanded, setIsExpanded] = useState(false)
  const [isOverflowing, setIsOverflowing] = useState(false)

  useLayoutEffect(() => {
    const element = textRef.current
    if (!element || isExpanded) return
    setIsOverflowing(element.scrollHeight > element.clientHeight + 1)
  }, [text, isExpanded])

  return (
    <section className="mt-3 max-w-3xl rounded-lg border border-l-4 border-gray-200 border-l-secondary bg-white px-4 py-3 shadow-sm">
      <p className="text-[10px] font-semibold uppercase tracking-wider text-gray-400">
        Description
      </p>
      <p
        ref={textRef}
        className={`mt-1 whitespace-pre-line text-sm leading-relaxed text-gray-800 ${
          isExpanded ? "" : "line-clamp-3"
        }`}
      >
        {text}
      </p>
      {(isOverflowing || isExpanded) && (
        <button
          className="mt-1 text-xs font-medium text-secondary_dark hover:underline"
          type="button"
          onClick={() => setIsExpanded((value) => !value)}
        >
          {isExpanded ? "Show less" : "Show more"}
        </button>
      )}
    </section>
  )
}

export default EventDescription
